import script from "./GarantiaDevolucionItem.vue?vue&type=script&setup=true&lang=js"
export * from "./GarantiaDevolucionItem.vue?vue&type=script&setup=true&lang=js"

import "./GarantiaDevolucionItem.vue?vue&type=style&index=0&id=2d8d68c3&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d8d68c3"]])

export default __exports__